<form [formGroup]="form()">
    <div class="form-group" [class.mb-3]="!standalone()">
        @if (label()) {
            <div class="d-flex justify-content-between align-items-center gap-3"
                [ngClass]="{
                    'mb-3': !labelIsHidden() && height() === inputBoxHeight.Md,
                    'mb-5': !labelIsHidden() && height() === inputBoxHeight.Lg,
                }">
                <label id="{{ id() }}Label"
                    for="{{ id() }}"
                    class="heading-5 fw-bold mb-0"
                    [ngClass]="{
                        'sr-only': labelIsHidden(),
                    }">{{ label() }}</label>
                @if (required()) {
                    <span class="badge bg-lighter-grey text-dark-grey fs-8">Required</span>
                }
            </div>
            @if (subLabel()) {
                <span class="heading-6 fw-semi-bold muted mb-3 d-block">{{ subLabel() }}</span>
            }
        }
        <div class="input-group puggles-input-group">
            @if (imagePath()) {
                <span class="input-group-text puggles-input-group-icon"
                    [class.bg-light-grey]="readOnly()"
                    [class.is-valid]="valid() && !readOnly()"
                    [class.is-invalid]="!ignoreValidation() && form().get(id())?.invalid && (form().get(id())?.dirty || form().get(id())?.touched)">
                    <img alt="Search" [src]="imagePath()" height="16px" width="16px" />
                </span>
            }
            <input tabindex="0" [type]="type()"
                id="{{ id() }}"
                [formControlName]="id()"
                class="form-control"
                [ngClass]="imagePath() ? 'puggles-input-group-text-field' : 'puggles-text-field'"
                [class.bg-lighter-grey]="readOnly()"
                [class.is-valid]="valid() && !readOnly()"
                [class.is-invalid]="invalid() || (!ignoreValidation() && form().get(id())?.invalid && (form().get(id())?.dirty || form().get(id())?.touched))"
                [class.puggles-text-field-large]="height() === inputBoxHeight.Lg"
                [class.text-grey]="readOnly()"
                [placeholder]="placeholder()"
                [readOnly]="readOnly()"
                [autocomplete]="autoComplete()"
                [autofocus]="autoFocus()"
                (change)="fileSelected.emit($event)"
                (keyup)="inputUpdate.emit($event)">
        </div>
        @if (formatPlaceholder() || verifiable()) {
            <div class="d-flex mt-3">
                @if (formatPlaceholder()) {
                    <span class="fw-bold fs-8">{{ formatPlaceholder() }}</span>
                }
                @if (verifiable(); as v) {
                    @if (v.isVerified) {
                        <div class="d-flex ms-auto flex-end align-items-center">
                            <fa-icon [icon]="iconLibrary.SUCCESS" class="text-success" />
                            <span class="ms-2 fw-bold fs-8">Verified</span>
                        </div>
                    }
                    @else {
                        <div class="d-flex ms-auto flex-end align-items-center">
                            <fa-icon [icon]="iconLibrary.CIRCLE_CROSS" class="text-danger" />
                            <span class="ms-2 fw-bold fs-8">Not verified. <a tabindex="0" [routerLink]="" class="text-link cursor-pointer" (click)="verifyAction.emit()">Verify now?</a></span>
                        </div>
                    }
                }
            </div>
        }
        @if (invalid() || (!ignoreValidation() && form().get(id())?.invalid && (form().get(id())?.dirty || form().get(id())?.touched))) {
            <div class="mt-2 ps-1 fs-7 fw-semi-bold text-danger">
                @if (form().get(id())?.errors?.['required']) {
                    <p class="mb-1">{{ getValidationMessage('required') ?? strings.formValueIsRequired }}</p>
                }
                @if (form().get(id())?.errors?.['pattern']) {
                    <p class="mb-1">{{ getValidationMessage('pattern') ?? strings.formPatternIncorrect }}</p>
                }
                @if (form().get(id())?.errors?.['passwordDoesNotMeetRequirements']) {
                    <p class="mb-1">{{ getValidationMessage('passwordDoesNotMeetRequirements') ?? strings.formPasswordDoesNotMeetRequirements }}</p>
                }
                @if (form().get(id())?.errors?.['passwordsDoNotMatch']) {
                    <p class="mb-1">{{ strings.formPasswordsDoNotMatch }}</p>
                }
                @if (form().get(id())?.errors?.['usernameAlreadyExists']) {
                    <p class="mb-1">{{ strings.formUsernameAlreadyExists }}</p>
                }
            </div>
        }
    </div>
</form>
